<template>
<!-- :style="{maxWidth: pageWidth+'px'}" -->
    <div class="main el-container">
		<Common :pageData='pageContent'></Common>
	</div>
</template>
<script>
import Common from '@/mode/common.vue'
import EventBus from '@/utils/EventBus.js'
export default {
    components: {
        Common,
    },
	data () {
		return {
            imgShow:true,
            pageWidth: '1200',
            pageContent: [],
		}
	},
    mounted(){
        this.getPageContent();
        EventBus.$on('getHomePage',data => {
            this.getPageContent()
            console.log(sessionStorage.language,9999999);
        })
    },
    methods:{
        getPageContent(){
            // let link = window.location.href.split('#')[0];
            this.$axios({
                method: 'post',
                url:'/api/page',
                data:{
                    type: 5,
                    // href: link,
                    // href: 'https://www.thmgmt.net/',
                    href: 'https://www.wennoanimal.com/website/',
                }
            }).then(res => {
                console.log(res);
                if(res.status == 200){
                    this.pageContent = res.data;
                    this.pageWidth = res.width;
                }else{
                    this.pageContent = [];
                    this.pageWidth = '1200';
                    // this.$router.push('/');
                }
            }).catch(error=>{

            });
        },
        toLink(link){
            window.open(link);
        }
    }
}
</script>
<style scoped>
    /deep/ .el-carousel__container{height: 100%;}
    /deep/ .el-carousel__button{width: 10px;height: 10px;border-radius: 50%;}
    /deep/ .el-carousel__arrow{width: 50px;height: 50px;font-size: 25px;}
    /*.main{width: 100%;height: auto;}*/
    .bannerContent{
        width: 100%;height: 100%;position: relative;
    }
    .bannerBtns{
        position: absolute;bottom: 20%;left: 20%;z-index: 2;text-align:left;
    }
    .tagLine{
        height: 80px;line-height:80px;font-size: 50px;color: #fff;
    }
    .tagBtn{
        display:inline-block;
        width: 250px;
        height: 60px;
        line-height: 60px;
        color: #fff;margin-right: 8px;
        background:rgb(154, 216, 218);border-radius: 40px;text-align: center;
        font-size: 40px;border: none;outline: none;
    }

    /*why people*/
    .why{
        width: 100%;position: relative;margin-bottom:20px;
    }
    .el-container {
        margin: 0;
    }
    .pink{
        width: 100%;height: 300px;background: #FFD0E0;
    }
    .pinkTitle{
        width: 100%;color: #fff;
    }
    .pinkTitle>div:first-child{
        height: calc( 100vw / 1920 * 150);line-height: calc( 100vw / 1920 * 150);
        font-size: 50px;text-align: center;
    }
    .pinkTitle>div:nth-child(2){
        display:none;
    }
    .workContent{
        display: flex;
        justify-content: space-around;
        margin-top: -150px;
    }
    .workItem{
        width: 30%;
        text-align: center;
        color: #7B5C55;
    }
    .workImg{
        width: 50%;height:auto;
        border-radius: 50%;
        background-color: #fff;
    }
    .workTitle{
        height: 50px;
        line-height: 50px;
        font-size: 28px;
    }
    .workText{
        width: 100%;
        height: auto;
        line-height: 20px;
        overflow: hidden;
        font-size: 16px;
        margin-bottom: 20px;
    }

    .whyContent{
        margin: 10px auto;
    }
    .whyItem{
        width: 30%;height: 100%;background-color: #fff;border:1px solid #E8E8E8;
        box-shadow: 5px 10px 8px #E8E8E8;border-radius: 10px;
    }
    .whyText{
        width: 86%;margin-left: 7%;margin-top:50px;height: 150px;font-size: 24px;
        line-height: 30px;color: #7B5C55;
    }
    .whyStar{
        width: 86%;margin-left: 7%;color:#7B5C55;height: 40px;line-height: 40px;
        font-size: 30px;display: flex;justify-content: space-between;
    }
    .whyStar i{font-size: 40px;}
    /*手机*/
    @media screen and (max-width: 768px){
        .bannerBtns{
            left:10%;bottom:20%;
        }
        .tagLine{
            height: 40px;line-height:40px;font-size:20px;
        }
        .tagBtn{
            width: 120px;height: 34px;line-height:34px;
            font-size: 16px;
        }

        /*why people*/
        .why{
            width: 100%;position: relative;
        }
        .whyItem{
            width: 100%;height:160px;margin-bottom: 10px;
            display: flex;flex-direction: column;
        }
        .whyText{width:90%;margin-left:5%;margin-top:20px;height:135px;font-size: 14px;}
        .whyStar{
            width: 86%;margin-left: 7%;color:#7B5C55;height: 35px;line-height: 35px;
            font-size: 14px;
        }
        .whyStar i{font-size: 30px;}
        .whyContent{
            width: 90%;margin:0 auto;height: auto;
        }
        .pink{
            width: 100%;height: 200px;background: #FFD0E0;
        }
        .pinkTitle{
            position: relative;width: 100%;height: 60px;line-height: 60px;
            color: #484848;
        }
        .pinkTitle>div:first-child{
            font-size: 25px;line-height: 100px;/*padding:calc( 100vw / 1920 * 48) 0;*/
        }

        .workContent{
            width: 90%;
            height: auto;
            margin: auto;
            display:block;
            margin-top: -100px;
        }
        .title{
            width: 100%;font-size: 30px;color: #484848;
            height: 60px;line-height: 60px;
            padding-top: calc( 100vw / 1920 * 50);
        }
        .workItem{
            width: 100%;
        }
        .workImg{
            width: 40%;height:auto;
        }
        .workTitle{
            height: 50px;
            line-height: 50px;
            font-size: 22px;
        }
        .workText{
            font-size: 14px;
            line-height: 20px;
            padding-bottom: 20px;
            margin-bottom: 0;
        }
    }
    /*平板*/
    @media screen and (min-width: 768px) and (max-width: 992px){
        .bannerBtns{
            left:15%;bottom:20%;
        }
        .tagLine{
            height: 40px;line-height:40px;font-size:24px;
        }
        .tagBtn{
            width: 130px;height: 40px;line-height:40px;
            font-size: 20px;
        }
        /*why people*/
        .why{
            width: 100%;position: relative;
        }
        .whyContent{
            width: 90%;
            margin:0 auto;
            height: 220px;
            display: flex;
            justify-content: space-around;
        }
        .whyItem{
            width:32%;height:200px;
        }
        .pink{
            width: 100%;height: 220px;background: #FFD0E0;
        }
        .pinkTitle{
            width: 100%;color: #fff;
        }
        .pinkTitle>div:first-child{
            font-size: 42px;height: calc( 100vw / 1920 * 110);line-height: calc( 100vw / 1920 * 110);
        }
        .workContent{
            width: 90%;
            height: auto;
            margin: auto;
            margin-top: -110px;
            display: flex;
        }
        .title{
            font-size: 40px;
            height: 80px;
            width: 100%;
            padding-top: calc( 100vw / 1920 * 50);
        }
        .workItem{
            width: 33%;
        }
        .workImg{
            width: 40%;height:auto;
        }
        .workTitle{
            height: 50px;
            line-height: 50px;
            font-size: 24px;
        }
        .workText{
            font-size: 14px;
        }

        .whyText{
            margin-top:20px;height: 130px;font-size: 18px;
        }
        .whyStar{
            font-size: 20px;
        }
        .whyStar i{font-size: 34px;}
    }
    /*中等屏幕*/
    @media screen and (min-width: 992px) and (max-width: 1200px){
        .bannerBtns{
            left:20%;bottom:20%;
        }
        .tagLine{
            height: 60px;line-height:60px;font-size:30px;
        }
        .tagBtn{
            width: 160px;height: 40px;line-height:40px;
            font-size: 24px;
        }
        /*why people*/
        .why{
            width: 100%;position: relative;
        }
        .whyContent{
            width: 90%;
            /*position: absolute;
            left: 5%;
            top: 125px;*/
            height: 250px;
            display: flex;
            justify-content: space-around;
        }
        .pink{
            width: 100%;height: 250px;background: #FFD0E0;
        }
        .pinkTitle{
            width: 100%;color: #fff;
        }
        .pinkTitle>div:first-child{
            font-size: 46px;height: calc( 100vw / 1920 * 125);line-height: calc( 100vw / 1920 * 125);/*padding:calc( 100vw / 1920 * 48) 0;*/
        }
        .whyText{
            margin-top:40px;height: 150px;font-size: 21px;
        }
        .whyStar{
            font-size: 24px;
        }
        .whyStar i{font-size: 36px;}

        .workContent{
            width: 90%;
            height: auto;
            margin: auto;
            margin-top: -125px;
        }
        .title{
            font-size: 44px;
            height: 80px;
            width: 100%;
            padding-top: calc( 100vw / 1920 * 50);
        }
        .workItem{
            width: 30%;
        }
        .workImg{
            width: 45%;height:auto;
        }
        .workTitle{
            height: 50px;
            line-height: 50px;
            font-size: 26px;
        }
        .workText{
            font-size: 15px;
        }
    }
    /*大屏幕*/
    @media screen and (min-width: 1200px){
        .workContent{
            width: 90%;
            max-width: 1200px;
            height: auto;
            margin: auto;
            margin-top: -150px;
        }
        .whyContent{
            width: 90%;
            /*position: absolute;
            left: 5%;
            top: 150px;*/
            margin: 10px auto;
            height: 300px;
            display: flex;
            justify-content: space-around;
        }
    }
</style>



// WEBPACK FOOTER //
// src/newpage/NewIndex.vue